<template>
  <div class="home">
    <div class="home_main_component">
      <div class="columns">
        <div class="column">
          <h2 class="home_main_title">Fast Reading.</h2>
          <p>Flatte（フラッテ）は、「テキスト・ストリーミング」と言う技術を使い、まるでフラッシュ暗算や速読のように高速で文章を読むことができるサービスです。</p>
        </div>
        <div class="column">
          <img alt="logo" src="../assets/home_main_image.png">
        </div>
      </div>
    </div>
    <hr class="home_main_border">
    <div class="home_fuetured">
      <div class="home_featured_component">
        <h2 class="home_featured_title">Flatteの特徴</h2>
          <p class="home_featured_explain_flash">{{this.featured_text[this.read_number]}}</p>
          <div class="home_featured_explain_flash_button">
            <span v-if="this.read_number ==0 "><b-button @click="autoFeaturedCountUp">再生</b-button></span>
            <span v-else><b-button disabled>再生</b-button></span>
          </div>
          <div class="home_featured_explain">
            <p>Flatteは、フラッシュ暗算のように次々と文章を表示することで、<strong>目を動かさずに文章を読むことができるサービス</strong>です。</p>
            <p>従来の文章を読む動作は、文章を読んでいる時間のうち、<strong>80%が物理的に眼球を動かすことに費やされており、実際に文章を読解する処理にはたったの20%の時間しか充てられていない</strong>ことが明らかになっています。</p>
            <p>そこで、Flatteでは、同じ場所に高速で文章を表示させる<strong>「テキスト・ストリーミング」</strong>と呼ばれる方法で文章を読むスピードを上げています。</p>
          </div>
      </div>
    </div>
    <div class="home_literature">
      <div class="home_literature_component">
        <h2 class="home_literature_title">日本の文学</h2>
        <p class="home_literature_subtitle">日本の不朽の名作を読む</p>
        <div class="home_literatures-list">
            <ul class="columns is-mobile is-multiline">
                <li class="column is-one-quarter-desktop is-one-quarter-tablet is-half-mobile" v-for="list in literature_list" :key="list.index">
                  <router-link :to="{name:'Literature', params: { id: list.params }}">
                      <img :src="list.url" alt="list.title">
                          <p>{{list.title}}</p>
                      <p>{{list.author}}</p>
                  </router-link>
                </li>
            </ul>
        </div>
        <p class="home_literature_button">
          <b-button @click="goToLiteratures" size="is-medium">さらに見る</b-button>
        </p>
      </div>
    </div>
    <div class="home_conversion">
      <div class="home_conversion_component">
        <h2 class="home_conversion_title">テキスト変換</h2>
        <p class="home_conversion_subtitle">読みたい文章をテキスト・ストリーミングに変換できます</p>
        <p class="home_conversion_image"><img alt="" src="../assets/home_conversion_image.png"></p>
        <p class="home_conversion_button"><router-link :to="{ name: 'Conversion' }"><b-button size="is-medium">使ってみる</b-button></router-link></p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Home',
  data(){
    return{
      read_number: 0,
      featured_text:[],
      literature_list: [],
      timerObj:[],
    }
  },
  created(){
    const row_featured_text = require('../json_file/literature/featured_explain.json')
    this.featured_text = row_featured_text.explain
    const row_home_literature_list = require('../json_file/literature/literature_list.json')
    this.literature_list = row_home_literature_list.literature_list_data.slice(0, 4)
  },
  mounted(){
    this.autoFeaturedCountUp()
    const title = "ホーム｜Flatte"
    document.title = title
    document.querySelector("meta[property='og:title']").setAttribute('content', title)
  },
  methods: {
    autoFeaturedCountUp(){
      this.timerObj = setInterval(() => {
        if(this.read_number >= this.featured_text.length -1){
          clearInterval(this.timerObj);
          this.read_number = 0
        }else{
          this.read_number ++
        }
        }
        ,250
      )
    },
    goToLiteratures(){
      this.$router.push({ path: 'literature' })
    }
  }
}
</script>
<style>
.home{
  padding: 80px 0 0 0;
}
.home_main_component{
  max-width: 960px;
  margin: auto;
  padding: 0 40px;
}
.home_main_title{
    font-size: 2.7rem;
    padding: 0 0 20px 0;
    font-weight: bold;
}
.home_main_border{
  margin: 64px 0 0 0;
}
.home_fuetured{
  padding: 48px 16px;
  background-color: #EBF5FF;
}
.home_featured_component{
  max-width: 960px;
  margin: auto;
}
.home_featured_title{
  text-align: center;
  font-size: 2.4rem;
  margin: 24px 0 40px;
  font-weight: bold;
}
.home_featured_explain_flash{
  padding:24px 0;
  font-size: 1.5rem;
  text-align: center;
  font-weight: bold;
}
.home_featured_explain_flash_button{
  text-align: center;
}
.home_featured_explain{
  margin: 40px 0 0 0;
  padding: 24px;
  background-color: white;
  border-radius: 1rem;
}
.home_featured_explain p{
  padding: 4px 0;
}
.home_literature{
  padding: 48px 16px;
  background-color: #F6F9F9;
}
.home_literature_component{
  max-width: 880px;
  margin: auto;
}
.home_literature_title{
  font-size: 2.4rem;
  padding: 0 0 20px 0;
  font-weight: bold;
}
.home_literature_subtitle{
  font-size: 0.9rem;
  color:gray;
}
.home_literatures-list{
  padding:40px 0 24px 0;
}
.home_literature_button{
  text-align: center;
}
.home_conversion{
  padding: 48px 16px;

}
.home_conversion_component{
  max-width: 880px;
  margin: auto;
}
.home_conversion_title{
  font-size: 2.2rem;
  padding: 0 0 20px 0;
  font-weight: bold;
  text-align: left;
}
.home_conversion_subtitle{
  font-size: 0.9rem;
}
.home_conversion_image{
  text-align: center;
}
.home_conversion_button{
  text-align: center;
}
</style>
